import { createFileRoute, Link } from "@tanstack/react-router";
import { AppShell } from "@/components/AppShell";
import { Package } from "lucide-react";

export const Route = createFileRoute("/_authenticated/purchases")({
  head: () => ({ meta: [{ title: "Purchases — Want To Buy" }] }),
  component: PurchasesPage,
});

function PurchasesPage() {
  return (
    <AppShell>
      <div className="mb-6">
        <h1 className="font-display text-3xl font-bold flex items-center gap-2">
          <Package className="h-7 w-7 text-primary" /> Purchases
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">Completed buy transactions where you were the buyer.</p>
      </div>

      <div className="panel p-10 text-center text-sm text-muted-foreground">
        <p>No purchases yet.</p>
        <p className="mt-2">
          <Link to="/create-order" className="text-primary hover:underline">Post your first buy order</Link> to get started.
        </p>
      </div>
    </AppShell>
  );
}
